/**
 * Tailwind class-name utility — combines clsx + tailwind-merge.
 * Last-class-wins for conflicting Tailwind utilities.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Reduced-motion media query — SSR-safe.
 * Hook consumers must wrap in useEffect for client-only behavior.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Two-weights-only enforcement — ensure no invalid Tailwind weights slip in.
 * Use only: 400 (regular) and 600 (semibold).
 */
export const allowedWeights = ['font-normal', 'font-semibold'] as const;
export type AllowedWeight = (typeof allowedWeights)[number];
